import { PolicyStatementBuilder } from '../components/PolicyStatementBuilder';
import type { AgentTemplateWizardStepType, WizardDraft, WizardStepProps } from '../types';

type PoliciesIntent = WizardDraft['policies'];

/**
 * `attach-policy` step (design §13): user-added grant rows, optional. On
 * create they are wrapped into the ONE fixed spec
 * `{name: 'wizard-extra-grants', statements}` for
 * `POST /agent/factories/:id/policies` (the wrapper is applied by the wizard
 * page / detail page so the name stays a single source). Escalation denials
 * (403 `agents:policy-subset-violation`) render inline via `SubsetDeniedAlert`
 * in the attach sequence — never a bare toast (§13.3).
 */
function AttachPolicyStep({ value, onChange, errors, onErrors }: WizardStepProps) {
  const policies: PoliciesIntent =
    value && typeof value === 'object' && 'statements' in (value as PoliciesIntent)
      ? (value as PoliciesIntent)
      : { statements: [] };

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Grant extra permissions. You can only grant permissions you already hold.
      </p>
      <p className="text-sm font-medium">Statements</p>
      <PolicyStatementBuilder
        statements={policies.statements}
        onChange={(statements) => onChange({ ...policies, statements })}
        errors={errors}
        onErrors={onErrors}
      />
    </div>
  );
}

export const type: AgentTemplateWizardStepType = 'attach-policy';
export const component = AttachPolicyStep;
